const state = {
    water: {
        // SHVE15: {
        //     name: 'СXВЭ-15',
        //     short: 'Счетчик холодной воды крыльчатый электронный',
        //     heading: 'Счетчик холодной воды крыльчатый электронный, СХВЭ-15 (счетчик +радиомодуль)',
        //     label: 'sale_lider.svg',
        //     imageUrl: 'c_6.png',
        //     advantage: 'Автоматическая передача данных в ГИС ЖКХ',
        //     advantageShort: 'Автопередача показаний',
        //     advantageSecondary: 'Все настроено, начните работу уже сегодня!',
        //     inStock: true,
        //     inStockText: 'Товар в наличии',
        //     notInStockText: 'Под заказ',
        //     inStockImage: 'done.svg',
        //     delivery: 'Бесплатная доставка по Новосибирску',
        //     popular: true,
        //     price: '2 455',
        //     currency: 'руб',
        //     buyButton: 'Заказать',
        //     productCode: '135449487',
        //     downloads: [
        //         {link: '/', name: 'Руководство по эксплуатации'},
        //         {link: '/', name: 'Драйвер для COM-порта'},
        //         {link: '/', name: 'Свидетельство об утверждении типа СИ'},
        //         {link: '/', name: 'Декларация соответствия ТР ТС'},
        //     ],
        //     excellence: [
        //         {icon: 'calendar.svg', name: 'Автоматическая передача<br />показаний в выбраный день'},
        //         {icon: 'broadcast.svg', name: 'Опрос счетчиков в<br />любое время'},
        //         {icon: 'check-form.svg', name: 'Хранит журнал показаний<br />и отчеты потребления'},
        //         {icon: 'time-left.svg', name: 'Беспроводная передача<br />данных из труднодоступных мест'}
        //     ],
        //     characteristics: [
        //         'Диапаззон рабочего давления воды до 1МПА',
        //         'Диапаззон рабочих температур воды для СХВЭ +5...+50 °С',
        //         'Способ активации в сети LoRaWAN™<br />ABP или OTAA',
        //         'Диаметр условного прохода 15 или 20мм',
        //         'Диапаззон рабочего давления воды до 1МПА',
        //         'Диапаззон рабочих температур воды для СХВЭ +5...+50 °С',
        //         'Способ активации в сети LoRaWAN™<br />ABP или OTAA',
        //         'Диаметр условного прохода 15 или 20мм'
        //     ],
        //     description: '<p>Счетчик электронный крыльчатый применяется для ' +
        //     'учета расхода холодной и горячей воды с накоплением и передачей этих данных в сеть LaRoWAN<br />' +
        //     'Функция "Электронная антимагнитная пломба" фиксирует воздействие внешним магнитным полем и' +
        //     'блокирует отображение показаний на дисплее устройства.</p><p>Счетчики выпускаются в двух' +
        //     'исполнениях: с диаметром условного прохода 15мм - 20мм </p>',
        //     labels: [
        //         {icon: 'Group 3069.svg', tip: 'Обеспечивает милиампер часы милиамперным милиамперметром'},
        //         {
        //             icon: 'Group 3070.svg',
        //             tip: 'Обеспечивает защиту от воды и других жидкостей только в виде капель и не защищает от струй воды'
        //         },
        //         {
        //             icon: 'Group 3071.svg',
        //             tip: 'Обеспечивает защиту от воды и других жидкостей только в виде капель и не защищает от струй воды'
        //         },
        //         {
        //             icon: 'Group 30699.svg',
        //             tip: 'Обеспечивает защиту от воды и других жидкостей только в виде капель и не защищает от струй воды'
        //         },
        //         {
        //             icon: 'Group 30711.svg',
        //             tip: 'Обеспечивает защиту от воды и других жидкостей только в виде капель и не защищает от струй воды'
        //         },
        //         {
        //             icon: '5kPaGray.svg',
        //             tip: 'Обеспечивает защиту от воды и других жидкостей только в виде капель и не защищает от струй воды'
        //         }
        //     ],
        //     warranty: 'Гарантия 5 лет'
        // },
        WFK15: {
            name: 'WFK-15',
            short: 'Счетчик холодной воды Itelma с LoRaWAN, ду-15мм',
            heading: 'Счетчик механический холодной воды Itelma с модулем LoRaWAN, ду-15мм',
            label: 'sale_lider.svg',
            // imageUrl: 'c_6.png',
            imageUrl: 'product-ITELMA-cold-lora.jpg',
            advantage: 'Автоматическая передача данных в ГИС ЖКХ',
            advantageShort: 'Автопередача показаний',
            advantageSecondary: 'Все настроено, начните работу уже сегодня!',
            inStock: true,
            inStockText: 'Товар в наличии',
            notInStockText: 'Под заказ',
            inStockImage: 'done.svg',
            delivery: 'Бесплатная доставка по Новосибирску',
            popular: true,
            price: '2 300',
            currency: 'руб',
            buyButton: 'Заказать',
            productCode: '135449487',
            downloads: [
                {link: 'full_technical_documentation_Itelma.pdf', name: 'Полное техническое описание'},
                {link: 'installation_manual_Itelma.pdf', name: 'Инструкция по монтажу'},
                {link: 'certificate_of_type_approval_Itelma.pdf', name: 'Свидетельство утверждения типа'},
                {link: 'certificate_of_conformity_Itelma.pdf', name: 'Сертификат соответствия 2019'},
                {link: 'certificate_of_approval_KZ.pdf', name: 'Сертификат утверждения типа Казахстан'},
                {link: 'expert_opinion_Itelma.pdf', name: 'Экспертное заключение центра гигиены и эпидемиологии'},
            ],
            excellence: [
                {icon: 'calendar.svg', name: 'Автоматическая передача<br />показаний в выбраный день'},
                {icon: 'broadcast.svg', name: 'Беспроводная передача<br />данных из труднодоступных мест'},
                {icon: 'check-form.svg', name: 'Хранит журнал показаний<br />и отчеты потребления'},
                {icon: 'time-left.svg', name: 'Опрос счетчиков в<br />любое время'}
            ],
            characteristics: [
                {
                    title: 'Диаметр условного прохода, мм',
                    value: '15'
                },
                {
                    title: 'Монтажная длина, мм',
                    value: '80/110'
                },
                {
                    title: 'Тип дисплея',
                    value: 'механический'
                },
                {
                    title: 'Температура воды, °C',
                    value: 'от +5 до +90'
                },
                {
                    title: 'Метрологический класс (по ГОСТ Р50193.1.93)',
                    value: 'A (вертикальная установка)<br>B (горизонтальная установка)'
                },
                {
                    title: 'Гарантийный срок эксплуатации, лет',
                    value: '6'
                },
                {
                    title: 'Срок службы счетчика, лет, не менее',
                    value: '12'
                },
                {
                    title: 'Меповерочный интервал, лет',
                    value: '6'
                }
            ],
            description: '<p>Счетчики с установленным на них радиомодулем предназначены для ' +
            'измерения объема холодной воды, протекающей в системах водоснабжения. <br />' +
            'Модуль радиоканала установлен в специальном' +
            'корпусе и обеспечивает считывание данных со стрелки долей счетчика.' + 
            'Считанные данные передаются через радиоканал на сервер LoRaWAN, где' +
            'обеспечивается их постоянное хранение и выдача потребителю по его запросу.</p>' +
            '<p>Ежемесячная абонентская плата за автоматическую передачу показаний - 16р/мес.</p>',
            labels: [
                // {icon: 'Group 3069.svg', tip: 'Обеспечивает милиампер часы милиамперным милиамперметром'},
                // {
                //     icon: 'Group 3070.svg',
                //     tip: 'Обеспечивает защиту от воды и других жидкостей только в виде капель и не защищает от струй воды'
                // },
                // {
                //     icon: 'Group 3071.svg',
                //     tip: 'Обеспечивает защиту от воды и других жидкостей только в виде капель и не защищает от струй воды'
                // },
                // {
                //     icon: 'Group 30699.svg',
                //     tip: 'Обеспечивает защиту от воды и других жидкостей только в виде капель и не защищает от струй воды'
                // },
                // {
                //     icon: 'Group 30711.svg',
                //     tip: 'Обеспечивает защиту от воды и других жидкостей только в виде капель и не защищает от струй воды'
                // },
                // {
                //     icon: '5kPaGray.svg',
                //     tip: 'Обеспечивает защиту от воды и других жидкостей только в виде капель и не защищает от струй воды'
                // }
            ],
            warranty: 'Гарантия 6 лет'
        },
        WFW15: {
            name: 'WFW-15',
            short: 'Счетчик горячей воды Itelma с LoRaWAN, ду-15мм',
            heading: 'Счетчик механический горячей воды Itelma с модулем LoRaWAN, ду-15мм',
            label: 'sale_lider.svg',
            // imageUrl: 'c_6.png',
            imageUrl: 'product-ITELMA-hot-lora.jpg',
            advantage: 'Автоматическая передача данных в ГИС ЖКХ',
            advantageShort: 'Автопередача показаний',
            advantageSecondary: 'Все настроено, начните работу уже сегодня!',
            inStock: true,
            inStockText: 'Товар в наличии',
            notInStockText: 'Под заказ',
            inStockImage: 'done.svg',
            delivery: 'Бесплатная доставка по Новосибирску',
            popular: true,
            price: '2 300',
            currency: 'руб',
            buyButton: 'Заказать',
            productCode: '135449487',
            downloads: [
                {link: 'full_technical_documentation_Itelma.pdf', name: 'Полное техническое описание'},
                {link: 'installation_manual_Itelma.pdf', name: 'Инструкция по монтажу'},
                {link: 'certificate_of_type_approval_Itelma.pdf', name: 'Свидетельство утверждения типа'},
                {link: 'certificate_of_conformity_Itelma.pdf', name: 'Сертификат соответствия 2019'},
                {link: 'certificate_of_approval_KZ.pdf', name: 'Сертификат утверждения типа Казахстан'},
                {link: 'expert_opinion_Itelma.pdf', name: 'Экспертное заключение центра гигиены и эпидемиологии'},
            ],
            excellence: [
                {icon: 'calendar.svg', name: 'Автоматическая передача<br />показаний в выбраный день'},
                {icon: 'broadcast.svg', name: 'Беспроводная передача<br />данных из труднодоступных мест'},
                {icon: 'check-form.svg', name: 'Хранит журнал показаний<br />и отчеты потребления'},
                {icon: 'time-left.svg', name: 'Опрос счетчиков в<br />любое время'}
            ],
            characteristics: [
                {
                    title: 'Диаметр условного прохода, мм',
                    value: '15'
                },
                {
                    title: 'Монтажная длина, мм',
                    value: '80/110'
                },
                {
                    title: 'Тип дисплея',
                    value: 'механический'
                },
                {
                    title: 'Температура воды, °C',
                    value: 'от +5 до +90'
                },
                {
                    title: 'Метрологический класс (по ГОСТ Р50193.1.93)',
                    value: 'A (вертикальная установка)<br>B (горизонтальная установка)'
                },
                {
                    title: 'Гарантийный срок эксплуатации, лет',
                    value: '6'
                },
                {
                    title: 'Срок службы счетчика, лет, не менее',
                    value: '12'
                },
                {
                    title: 'Меповерочный интервал, лет',
                    value: '6'
                }
            ],
            description: '<p>Счетчики с установленным на них радиомодулем предназначены для ' +
            'измерения объема горячей воды, протекающей в системах водоснабжения. <br />' +
            'Модуль радиоканала установлен в специальном' +
            'корпусе и обеспечивает считывание данных со стрелки долей счетчика.' + 
            'Считанные данные передаются через радиоканал на сервер LoRaWAN, где' +
            'обеспечивается их постоянное хранение и выдача потребителю по его запросу.</p>' +
            '<p>Ежемесячная абонентская плата за автоматическую передачу показаний - 16р/мес.</p>',
            labels: [],
            warranty: 'Гарантия 6 лет'
        },
        WFK20: {
            name: 'WFK-20',
            short: 'Счетчик холодной воды Itelma с LoRaWAN, ду-20мм',
            heading: 'Счетчик механический холодной воды Itelma с модулем LoRaWAN, ду-20мм',
            label: 'sale_lider.svg',
            // imageUrl: 'c_6.png',
            imageUrl: 'product-ITELMA-cold-lora.jpg',
            advantage: 'Автоматическая передача данных в ГИС ЖКХ',
            advantageShort: 'Автопередача показаний',
            advantageSecondary: 'Все настроено, начните работу уже сегодня!',
            inStock: true,
            inStockText: 'Товар в наличии',
            notInStockText: 'Под заказ',
            inStockImage: 'done.svg',
            delivery: 'Бесплатная доставка по Новосибирску',
            popular: true,
            price: '2 300',
            currency: 'руб',
            buyButton: 'Заказать',
            productCode: '135449487',
            downloads: [
                {link: 'full_technical_documentation_Itelma.pdf', name: 'Полное техническое описание'},
                {link: 'installation_manual_Itelma.pdf', name: 'Инструкция по монтажу'},
                {link: 'certificate_of_type_approval_Itelma.pdf', name: 'Свидетельство утверждения типа'},
                {link: 'certificate_of_conformity_Itelma.pdf', name: 'Сертификат соответствия 2019'},
                {link: 'certificate_of_approval_KZ.pdf', name: 'Сертификат утверждения типа Казахстан'},
                {link: 'expert_opinion_Itelma.pdf', name: 'Экспертное заключение центра гигиены и эпидемиологии'},
            ],
            excellence: [
                {icon: 'calendar.svg', name: 'Автоматическая передача<br />показаний в выбраный день'},
                {icon: 'broadcast.svg', name: 'Беспроводная передача<br />данных из труднодоступных мест'},
                {icon: 'check-form.svg', name: 'Хранит журнал показаний<br />и отчеты потребления'},
                {icon: 'time-left.svg', name: 'Опрос счетчиков в<br />любое время'}
            ],
            characteristics: [
                {
                    title: 'Диаметр условного прохода, мм',
                    value: '20'
                },
                {
                    title: 'Монтажная длина, мм',
                    value: '130'
                },
                {
                    title: 'Тип дисплея',
                    value: 'механический'
                },
                {
                    title: 'Температура воды, °C',
                    value: 'от +5 до +90'
                },
                {
                    title: 'Метрологический класс (по ГОСТ Р50193.1.93)',
                    value: 'A (вертикальная установка)<br>B (горизонтальная установка)'
                },
                {
                    title: 'Гарантийный срок эксплуатации, лет',
                    value: '6'
                },
                {
                    title: 'Срок службы счетчика, лет, не менее',
                    value: '12'
                },
                {
                    title: 'Меповерочный интервал, лет',
                    value: '6'
                }
            ],
            description: '<p>Счетчики с установленным на них радиомодулем предназначены для ' +
            'измерения объема холодной воды, протекающей в системах водоснабжения. <br />' +
            'Модуль радиоканала установлен в специальном' +
            'корпусе и обеспечивает считывание данных со стрелки долей счетчика.' + 
            'Считанные данные передаются через радиоканал на сервер LoRaWAN, где' +
            'обеспечивается их постоянное хранение и выдача потребителю по его запросу.</p>' +
            '<p>Ежемесячная абонентская плата за автоматическую передачу показаний - 16р/мес.</p>',
            labels: [],
            warranty: 'Гарантия 6 лет'
        },
        WFW20: {
            name: 'WFW-20',
            short: 'Счетчик горячей воды Itelma с LoRaWAN, ду-20мм',
            heading: 'Счетчик механический горячей воды Itelma с модулем LoRaWAN, ду-20мм',
            label: 'sale_lider.svg',
            // imageUrl: 'c_6.png',
            imageUrl: 'product-ITELMA-hot-lora.jpg',
            advantage: 'Автоматическая передача данных в ГИС ЖКХ',
            advantageShort: 'Автопередача показаний',
            advantageSecondary: 'Все настроено, начните работу уже сегодня!',
            inStock: true,
            inStockText: 'Товар в наличии',
            notInStockText: 'Под заказ',
            inStockImage: 'done.svg',
            delivery: 'Бесплатная доставка по Новосибирску',
            popular: true,
            price: '2 300',
            currency: 'руб',
            buyButton: 'Заказать',
            productCode: '135449487',
            downloads: [
                {link: 'full_technical_documentation_Itelma.pdf', name: 'Полное техническое описание'},
                {link: 'installation_manual_Itelma.pdf', name: 'Инструкция по монтажу'},
                {link: 'certificate_of_type_approval_Itelma.pdf', name: 'Свидетельство утверждения типа'},
                {link: 'certificate_of_conformity_Itelma.pdf', name: 'Сертификат соответствия 2019'},
                {link: 'certificate_of_approval_KZ.pdf', name: 'Сертификат утверждения типа Казахстан'},
                {link: 'expert_opinion_Itelma.pdf', name: 'Экспертное заключение центра гигиены и эпидемиологии'},
            ],
            excellence: [
                {icon: 'calendar.svg', name: 'Автоматическая передача<br />показаний в выбраный день'},
                {icon: 'broadcast.svg', name: 'Беспроводная передача<br />данных из труднодоступных мест'},
                {icon: 'check-form.svg', name: 'Хранит журнал показаний<br />и отчеты потребления'},
                {icon: 'time-left.svg', name: 'Опрос счетчиков в<br />любое время'}
            ],
            characteristics: [
                {
                    title: 'Диаметр условного прохода, мм',
                    value: '20'
                },
                {
                    title: 'Монтажная длина, мм',
                    value: '130'
                },
                {
                    title: 'Тип дисплея',
                    value: 'механический'
                },
                {
                    title: 'Температура воды, °C',
                    value: 'от +5 до +90'
                },
                {
                    title: 'Метрологический класс (по ГОСТ Р50193.1.93)',
                    value: 'A (вертикальная установка)<br>B (горизонтальная установка)'
                },
                {
                    title: 'Гарантийный срок эксплуатации, лет',
                    value: '6'
                },
                {
                    title: 'Срок службы счетчика, лет, не менее',
                    value: '12'
                },
                {
                    title: 'Меповерочный интервал, лет',
                    value: '6'
                }
            ],
            description: '<p>Счетчики с установленным на них радиомодулем предназначены для ' +
            'измерения объема горячей воды, протекающей в системах водоснабжения. <br />' +
            'Модуль радиоканала установлен в специальном' +
            'корпусе и обеспечивает считывание данных со стрелки долей счетчика.' + 
            'Считанные данные передаются через радиоканал на сервер LoRaWAN, где' +
            'обеспечивается их постоянное хранение и выдача потребителю по его запросу.</p>' +
            '<p>Ежемесячная абонентская плата за автоматическую передачу показаний - 16р/мес.</p>',
            labels: [],
            warranty: 'Гарантия 6 лет'
        }
    },
    electro: {
        // CE2726A: {
        //     name: 'ЦЭ2726А',
        //     short: 'Электронный однофазный счетчик без реле',
        //     heading: 'Электронный однофазный счетчик ЦЭ2726А в прямоугольном W03 корпусе, без реле ограничения нагрузки',
        //     imageUrl: 'product_electr_CE_W03.png',
        //     advantage: 'Автоматическая передача данных в ГИС ЖКХ',
        //     advantageShort: 'Автопередача показаний',
        //     advantageSecondary: '<span class="orange">Пользуется большим спросом!</span>',
        //     inStock: true,
        //     inStockText: 'Товар в наличии',
        //     notInStockText: 'Под заказ',
        //     inStockImage: 'done.svg',
        //     delivery: 'Бесплатная доставка по Новосибирску',
        //     price: '3970',
        //     currency: 'руб',
        //     buyButton: 'Заказать',
        //     productCode: '135449487',
        //     downloads: [
        //         {link: '/', name: 'Руководство по эксплуатации'},
        //         {link: '/', name: 'Драйвер для COM-порта'},
        //         {link: '/', name: 'Свидетельство об утверждении типа СИ'},
        //         {link: '/', name: 'Декларация соответствия ТР ТС'},
        //     ],
        //     excellence: [
        //         {icon: 'calendar.svg', name: 'Автоматическая передача<br />показаний в выбраный день'},
        //         {icon: 'broadcast.svg', name: 'Опрос счетчиков в<br />любое время'},
        //         {icon: 'check-form.svg', name: 'Хранит журнал показаний<br />и отчеты потребления'},
        //         {icon: 'time-left.svg', name: 'Беспроводная передача<br />данных из труднодоступных мест'}
        //     ],
        //     characteristics: [
        //         {
        //             title: 'Номинальное напряжение, В',
        //             value: '220, 230'
        //         },
        //         {
        //             title: 'Базовый - Максимальный ток, А',
        //             value: '5-60'
        //         },
        //         {
        //             title: 'Номинальная частота сети, Гц',
        //             value: '50'
        //         },
        //         {
        //             title: 'Количество тарифов',
        //             value: 'до 4'
        //         },
        //         {
        //             title: 'Передаточные числа по испытательному выходу и импульсному выходу устройству, имп./кВт⋅ч',
        //             value: '3200, 6400'
        //         }
        //     ],
        //     description: '<p>Счетчики ЦЭ2726А предназначены для многотарифного (до 4 тарифов) ' +
        //     'учета активной энергии в однофазных сетях переменного тока номинальной частотой 50 Гц.<br />' +
        //     'Счетчики соответствуют требованиям ГОСТ 31818.11-2012, ГОСТ 31819.21-2012. ' +
        //     'Счетчики устанавливаются внутри помещений, рабочий диапазон температур от минус 40 ºС до плюс 60 ºС. ' +
        //     'Степень защиты корпуса счетчика от проникновения воды и пыли внутрь счетчика соответствует IP51. ' +
        //     'Цепи напряжения и тока имеют защиту от бросков напряжения и тока.</p>' +
        //     '<p>Ежемесячная абонентская плата за автоматическую передачу показаний - 16р/мес.</p>',
        //     labels: [],
        //     warranty: 'Гарантия 5 лет'
        // },
        // CE2726AZR: {
        //     name: 'ЦЭ2726А Z.R.',
        //     short: 'Электронный однофазный счетчик с реле',
        //     heading: 'Электронный однофазный счетчик ЦЭ2726А в прямоугольном W03 корпусе, с реле ограничения нагрузки',
        //     imageUrl: 'product_electr_CE_W03.png',
        //     advantage: 'Автоматическая передача данных в ГИС ЖКХ',
        //     advantageShort: 'Автопередача показаний',
        //     advantageSecondary: '<span class="orange">Пользуется большим спросом!</span>',
        //     inStock: true,
        //     inStockText: 'Товар в наличии',
        //     notInStockText: 'Под заказ',
        //     inStockImage: 'done.svg',
        //     delivery: 'Бесплатная доставка по Новосибирску',
        //     price: '4370',
        //     currency: 'руб',
        //     buyButton: 'Заказать',
        //     productCode: '135449487',
        //     downloads: [
        //         {link: '/', name: 'Руководство по эксплуатации'},
        //         {link: '/', name: 'Драйвер для COM-порта'},
        //         {link: '/', name: 'Свидетельство об утверждении типа СИ'},
        //         {link: '/', name: 'Декларация соответствия ТР ТС'},
        //     ],
        //     excellence: [
        //         {icon: 'calendar.svg', name: 'Автоматическая передача<br />показаний в выбраный день'},
        //         {icon: 'broadcast.svg', name: 'Опрос счетчиков в<br />любое время'},
        //         {icon: 'check-form.svg', name: 'Хранит журнал показаний<br />и отчеты потребления'},
        //         {icon: 'time-left.svg', name: 'Беспроводная передача<br />данных из труднодоступных мест'}
        //     ],
        //     characteristics: [
        //         {
        //             title: 'Номинальное напряжение, В',
        //             value: '220, 230'
        //         },
        //         {
        //             title: 'Базовый - Максимальный ток, А',
        //             value: '5-60'
        //         },
        //         {
        //             title: 'Номинальная частота сети, Гц',
        //             value: '50'
        //         },
        //         {
        //             title: 'Количество тарифов',
        //             value: 'до 4'
        //         },
        //         {
        //             title: 'Передаточные числа по испытательному выходу и импульсному выходу устройству, имп./кВт⋅ч',
        //             value: '3200, 6400'
        //         }
        //     ],
        //     description: '<p>Счетчики ЦЭ2726А предназначены для многотарифного (до 4 тарифов) ' +
        //     'учета активной энергии в однофазных сетях переменного тока номинальной частотой 50 Гц.<br />' +
        //     'Счетчики соответствуют требованиям ГОСТ 31818.11-2012, ГОСТ 31819.21-2012. ' +
        //     'Счетчики устанавливаются внутри помещений, рабочий диапазон температур от минус 40 ºС до плюс 60 ºС. ' +
        //     'Степень защиты корпуса счетчика от проникновения воды и пыли внутрь счетчика соответствует IP51. ' +
        //     'Цепи напряжения и тока имеют защиту от бросков напряжения и тока. ' +
        //     'Оснащен реле ограничения нагрузки.</p>' +
        //     '<p>Ежемесячная абонентская плата за автоматическую передачу показаний - 16р/мес.</p>',
        //     labels: [],
        //     warranty: 'Гарантия 5 лет'
        // },
        CE2726A560: {
            name: 'ЦЭ2726А.А1.S.RF.ОР.5/60.W03.R',
            short: 'Электронный однофазный счетчик',
            heading: 'Электронный однофазный счетчик ЦЭ2726А в прямоугольном W03 корпусе, со встроенным модулем LoRaWAN',
            imageUrl: 'product_electr_CE_W03.png',
            advantage: 'Автоматическая передача данных в ГИС ЖКХ',
            advantageShort: 'Автопередача показаний',
            advantageSecondary: '<span class="orange">Пользуется большим спросом!</span>',
            inStock: true,
            inStockText: 'Товар в наличии',
            notInStockText: 'Под заказ',
            inStockImage: 'done.svg',
            delivery: 'Бесплатная доставка по Новосибирску',
            price: '4860',
            currency: 'руб',
            buyButton: 'Заказать',
            productCode: '135449487',
            downloads: [
                {link: '/', name: 'Руководство по эксплуатации'},
                {link: '/', name: 'Драйвер для COM-порта'},
                {link: '/', name: 'Свидетельство об утверждении типа СИ'},
                {link: '/', name: 'Декларация соответствия ТР ТС'},
            ],
            excellence: [
                {icon: 'calendar.svg', name: 'Автоматическая передача<br />показаний в выбраный день'},
                {icon: 'broadcast.svg', name: 'Опрос счетчиков в<br />любое время'},
                {icon: 'check-form.svg', name: 'Хранит журнал показаний<br />и отчеты потребления'},
                {icon: 'time-left.svg', name: 'Беспроводная передача<br />данных из труднодоступных мест'}
            ],
            characteristics: [
                {
                    title: 'Номинальное напряжение, В',
                    value: '220, 230'
                },
                {
                    title: 'Базовый - Максимальный ток, А',
                    value: '5-60'
                },
                {
                    title: 'Номинальная частота сети, Гц',
                    value: '50'
                },
                {
                    title: 'Количество тарифов',
                    value: 'до 4'
                },
                {
                    title: 'Передаточные числа по испытательному выходу и импульсному выходу устройству, имп./кВт⋅ч',
                    value: '3200, 6400'
                }
            ],
            description: '<p>Счетчики ЦЭ2726А предназначены для многотарифного (до 4 тарифов) ' +
            'учета активной энергии в однофазных сетях переменного тока номинальной частотой 50 Гц.<br />' +
            'Счетчики соответствуют требованиям ГОСТ 31818.11-2012, ГОСТ 31819.21-2012. ' +
            'Счетчики устанавливаются внутри помещений, рабочий диапазон температур от минус 40 ºС до плюс 60 ºС. ' +
            'Степень защиты корпуса счетчика от проникновения воды и пыли внутрь счетчика соответствует IP51. ' +
            'Цепи напряжения и тока имеют защиту от бросков напряжения и тока. ' +
            'На корпусе счетчика имеется датчик вскрытия.</p>' +
            '<p>Ежемесячная абонентская плата за автоматическую передачу показаний - 20р/мес.</p>',
            labels: [],
            warranty: 'Гарантия 5 лет'
        },
        CE2726A560R: {
            name: 'ЦЭ2726А.А1.S.RF.ОР.5/60.W03.Z.R',
            short: 'Электронный однофазный счетчик с реле',
            heading: 'Электронный однофазный счетчик ЦЭ2726А в прямоугольном W03 корпусе, с реле ограничения нагрузки и со встроенным модулем LoRaWAN',
            imageUrl: 'product_electr_CE_W03.png',
            advantage: 'Автоматическая передача данных в ГИС ЖКХ',
            advantageShort: 'Автопередача показаний',
            advantageSecondary: '<span class="orange">Пользуется большим спросом!</span>',
            inStock: true,
            inStockText: 'Товар в наличии',
            notInStockText: 'Под заказ',
            inStockImage: 'done.svg',
            delivery: 'Бесплатная доставка по Новосибирску',
            price: '5290',
            currency: 'руб',
            buyButton: 'Заказать',
            productCode: '135449487',
            downloads: [
                {link: '/', name: 'Руководство по эксплуатации'},
                {link: '/', name: 'Драйвер для COM-порта'},
                {link: '/', name: 'Свидетельство об утверждении типа СИ'},
                {link: '/', name: 'Декларация соответствия ТР ТС'},
            ],
            excellence: [
                {icon: 'calendar.svg', name: 'Автоматическая передача<br />показаний в выбраный день'},
                {icon: 'broadcast.svg', name: 'Опрос счетчиков в<br />любое время'},
                {icon: 'check-form.svg', name: 'Хранит журнал показаний<br />и отчеты потребления'},
                {icon: 'time-left.svg', name: 'Беспроводная передача<br />данных из труднодоступных мест'}
            ],
            characteristics: [
                {
                    title: 'Номинальное напряжение, В',
                    value: '220, 230'
                },
                {
                    title: 'Базовый - Максимальный ток, А',
                    value: '5-60'
                },
                {
                    title: 'Номинальная частота сети, Гц',
                    value: '50'
                },
                {
                    title: 'Количество тарифов',
                    value: 'до 4'
                },
                {
                    title: 'Передаточные числа по испытательному выходу и импульсному выходу устройству, имп./кВт⋅ч',
                    value: '3200, 6400'
                }
            ],
            description: '<p>Счетчики ЦЭ2726А предназначены для многотарифного (до 4 тарифов) ' +
            'учета активной энергии в однофазных сетях переменного тока номинальной частотой 50 Гц.<br />' +
            'Счетчики соответствуют требованиям ГОСТ 31818.11-2012, ГОСТ 31819.21-2012. ' +
            'Счетчики устанавливаются внутри помещений, рабочий диапазон температур от минус 40 ºС до плюс 60 ºС. ' +
            'Степень защиты корпуса счетчика от проникновения воды и пыли внутрь счетчика соответствует IP51. ' +
            'Цепи напряжения и тока имеют защиту от бросков напряжения и тока. ' +
            'Оснащен реле ограничения нагрузки. На корпусе счетчика имеется датчик вскрытия.</p>' +
            '<p>Ежемесячная абонентская плата за автоматическую передачу показаний - 20р/мес.</p>',
            labels: [],
            warranty: 'Гарантия 5 лет'
        },
        CE2726A560DIN: {
            name: 'ЦЭ2726А.А1.S.RF.5/60.R01',
            short: 'Электронный однофазный счетчик',
            heading: 'Электронный однофазный счетчик ЦЭ2726А в R01 корпусе на DIN-рейку со встроенным модулем LoRaWAN',
            imageUrl: 'product_electr_CE_R01.jpeg',
            advantage: 'Автоматическая передача данных в ГИС ЖКХ',
            advantageShort: 'Автопередача показаний',
            advantageSecondary: '<span class="orange">Пользуется большим спросом!</span>',
            inStock: true,
            inStockText: 'Товар в наличии',
            notInStockText: 'Под заказ',
            inStockImage: 'done.svg',
            delivery: 'Бесплатная доставка по Новосибирску',
            price: '4490',
            currency: 'руб',
            buyButton: 'Заказать',
            productCode: '135449487',
            downloads: [
                {link: '/', name: 'Руководство по эксплуатации'},
                {link: '/', name: 'Драйвер для COM-порта'},
                {link: '/', name: 'Свидетельство об утверждении типа СИ'},
                {link: '/', name: 'Декларация соответствия ТР ТС'},
            ],
            excellence: [
                {icon: 'calendar.svg', name: 'Автоматическая передача<br />показаний в выбраный день'},
                {icon: 'broadcast.svg', name: 'Опрос счетчиков в<br />любое время'},
                {icon: 'check-form.svg', name: 'Хранит журнал показаний<br />и отчеты потребления'},
                {icon: 'time-left.svg', name: 'Беспроводная передача<br />данных из труднодоступных мест'}
            ],
            characteristics: [
                {
                    title: 'Номинальное напряжение, В',
                    value: '220, 230'
                },
                {
                    title: 'Базовый - Максимальный ток, А',
                    value: '5-60'
                },
                {
                    title: 'Номинальная частота сети, Гц',
                    value: '50'
                },
                {
                    title: 'Количество тарифов',
                    value: 'до 4'
                },
                {
                    title: 'Передаточные числа по испытательному выходу и импульсному выходу устройству, имп./кВт⋅ч',
                    value: '3200, 6400'
                }
            ],
            description: '<p>Счетчики ЦЭ2726А предназначены для многотарифного (до 4 тарифов) ' +
            'учета активной энергии в однофазных сетях переменного тока номинальной частотой 50 Гц.<br />' +
            'Счетчики соответствуют требованиям ГОСТ 31818.11-2012, ГОСТ 31819.21-2012. ' +
            'Счетчики устанавливаются внутри помещений, рабочий диапазон температур от минус 40 ºС до плюс 60 ºС. ' +
            'Степень защиты корпуса счетчика от проникновения воды и пыли внутрь счетчика соответствует IP51. ' +
            'Цепи напряжения и тока имеют защиту от бросков напряжения и тока. ' +
            'На корпусе счетчика имеется датчик вскрытия. Для установки на DIN-рейку.</p>' +
            '<p>Ежемесячная абонентская плата за автоматическую передачу показаний - 20р/мес.</p>',
            labels: [],
            warranty: 'Гарантия 5 лет'
        },
        CE2727A560DIN: {
            name: 'ЦЭ2727А.S.RF.5-60.R02',
            short: 'Электронный трёхфазный счетчик',
            heading: 'Электронный трехфазный счетчик ЦЭ2727А в R02 корпусе на DIN-рейку со встроенным модулем LoRaWAN',
            imageUrl: 'product_electr_CE_R02.jpeg',
            advantage: 'Автоматическая передача данных в ГИС ЖКХ',
            advantageShort: 'Автопередача показаний',
            advantageSecondary: '<span class="orange">Пользуется большим спросом!</span>',
            inStock: true,
            inStockText: 'Товар в наличии',
            notInStockText: 'Под заказ',
            inStockImage: 'done.svg',
            delivery: 'Бесплатная доставка по Новосибирску',
            price: '5670',
            currency: 'руб',
            buyButton: 'Заказать',
            productCode: '135449487',
            downloads: [
                {link: '/', name: 'Руководство по эксплуатации'},
                {link: '/', name: 'Драйвер для COM-порта'},
                {link: '/', name: 'Свидетельство об утверждении типа СИ'},
                {link: '/', name: 'Декларация соответствия ТР ТС'},
            ],
            excellence: [
                {icon: 'calendar.svg', name: 'Автоматическая передача<br />показаний в выбраный день'},
                {icon: 'broadcast.svg', name: 'Опрос счетчиков в<br />любое время'},
                {icon: 'check-form.svg', name: 'Хранит журнал показаний<br />и отчеты потребления'},
                {icon: 'time-left.svg', name: 'Беспроводная передача<br />данных из труднодоступных мест'}
            ],
            characteristics: [
                {
                    title: 'Номинальное напряжение, В',
                    value: '3x 220/380; 3x230/400'
                },
                {
                    title: 'Базовый - Максимальный ток, А',
                    value: '5-60'
                },
                {
                    title: 'Стартовый ток (порог чувствительности) (при U= Uном, cosφ= 1), для счетчика непосредственного включения, % от Iб',
                    value: '0,4'
                },
                {
                    title: 'Количество тарифов',
                    value: 'до 4'
                },
                {
                    title: 'Постоянная счетчика, имп./кВт·ч',
                    value: '1000'
                }
            ],
            description: '<p>Счетчики ЦЭ2727А предназначены для многотарифного (до 4 тарифов) ' +
            'учета активной энергии в трехфазных трех- и четырех- проводных сетях переменного тока номинальной частотой 50 Гц.<br />' +
            'Счетчики соответствуют требованиям ГОСТ 31818.11-2012, ГОСТ 31819.21-2012. ' +
            'Счетчики устанавливаются внутри помещений, рабочий диапазон температур от минус 40 ºС до плюс 70 ºС. ' +
            'Подключаются непосредственно к электрической сети. ' +
            'Степень защиты корпуса счетчика от проникновения воды и пыли внутрь счетчика соответствует IP51. Для установки на DIN-рейку. ' +
            'Ежемесячная абонентская плата за автоматическую передачу показаний - 20р/мес.</p>',
            labels: [],
            warranty: 'Гарантия 5 лет'
        },
        CE2727A510: {
            name: 'ЦЭ2727А.Т.RF.ОР.5-10.В04',
            short: 'Электронный трёхфазный счетчик',
            heading: 'Электронный трехфазный счетчик ЦЭ2727А в плоском В04 корпусе, с оптопортом и встроенным модулем LoRaWAN',
            imageUrl: 'product_electr_CE_B04.jpeg',
            advantage: 'Автоматическая передача данных в ГИС ЖКХ',
            advantageShort: 'Автопередача показаний',
            advantageSecondary: '<span class="orange">Пользуется большим спросом!</span>',
            inStock: true,
            inStockText: 'Товар в наличии',
            notInStockText: 'Под заказ',
            inStockImage: 'done.svg',
            delivery: 'Бесплатная доставка по Новосибирску',
            price: '7100',
            currency: 'руб',
            buyButton: 'Заказать',
            productCode: '135449487',
            downloads: [
                {link: '/', name: 'Руководство по эксплуатации'},
                {link: '/', name: 'Драйвер для COM-порта'},
                {link: '/', name: 'Свидетельство об утверждении типа СИ'},
                {link: '/', name: 'Декларация соответствия ТР ТС'},
            ],
            excellence: [
                {icon: 'calendar.svg', name: 'Автоматическая передача<br />показаний в выбраный день'},
                {icon: 'broadcast.svg', name: 'Опрос счетчиков в<br />любое время'},
                {icon: 'check-form.svg', name: 'Хранит журнал показаний<br />и отчеты потребления'},
                {icon: 'time-left.svg', name: 'Беспроводная передача<br />данных из труднодоступных мест'}
            ],
            characteristics: [
                {
                    title: 'Номинальное напряжение, В',
                    value: '3x 220/380; 3x230/400'
                },
                {
                    title: 'Базовый - Максимальный ток, А',
                    value: '5-10'
                },
                {
                    title: 'Стартовый ток (порог чувствительности) (при U= Uном, cosφ= 1), для счетчиков трансформаторного включения, % от Iном',
                    value: '0,2'
                },
                {
                    title: 'Количество тарифов',
                    value: 'до 4'
                },
                {
                    title: 'Постоянная счетчика, имп./кВт·ч',
                    value: '1000'
                }
            ],
            description: '<p>Счетчики ЦЭ2727А предназначены для многотарифного (до 4 тарифов) ' +
            'учета активной энергии в трехфазных трех- и четырех- проводных сетях переменного тока номинальной частотой 50 Гц.<br />' +
            'Счетчики соответствуют требованиям ГОСТ 31818.11-2012, ГОСТ 31819.21-2012. ' +
            'Счетчики устанавливаются внутри помещений, рабочий диапазон температур от минус 40 ºС до плюс 70 ºС. ' +
            'Подключаются к электрической сети через измерительные трансформаторы тока. ' +
            'Степень защиты корпуса счетчика от проникновения воды и пыли внутрь счетчика соответствует IP51. ' +
            'Ежемесячная абонентская плата за автоматическую передачу показаний - 20р/мес.</p>',
            labels: [],
            warranty: 'Гарантия 5 лет'
        },
        CE2727A560: {
            name: 'ЦЭ2727А.S.RF.ОР.5-60.В04',
            short: 'Электронный трёхфазный счетчик',
            heading: 'Электронный трехфазный счетчик ЦЭ2727А в плоском B04, с оптопортом и встроенным модулем LoRaWAN',
            imageUrl: 'product_electr_CE_B04.jpeg',
            advantage: 'Автоматическая передача данных в ГИС ЖКХ',
            advantageShort: 'Автопередача показаний',
            advantageSecondary: '<span class="orange">Пользуется большим спросом!</span>',
            inStock: true,
            inStockText: 'Товар в наличии',
            notInStockText: 'Под заказ',
            inStockImage: 'done.svg',
            delivery: 'Бесплатная доставка по Новосибирску',
            price: '7125',
            currency: 'руб',
            buyButton: 'Заказать',
            productCode: '135449487',
            downloads: [
                {link: '/', name: 'Руководство по эксплуатации'},
                {link: '/', name: 'Драйвер для COM-порта'},
                {link: '/', name: 'Свидетельство об утверждении типа СИ'},
                {link: '/', name: 'Декларация соответствия ТР ТС'},
            ],
            excellence: [
                {icon: 'calendar.svg', name: 'Автоматическая передача<br />показаний в выбраный день'},
                {icon: 'broadcast.svg', name: 'Опрос счетчиков в<br />любое время'},
                {icon: 'check-form.svg', name: 'Хранит журнал показаний<br />и отчеты потребления'},
                {icon: 'time-left.svg', name: 'Беспроводная передача<br />данных из труднодоступных мест'}
            ],
            characteristics: [
                {
                    title: 'Номинальное напряжение, В',
                    value: '3x 220/380; 3x230/400'
                },
                {
                    title: 'Базовый - Максимальный ток, А',
                    value: '5-10'
                },
                {
                    title: 'Стартовый ток (порог чувствительности) (при U= Uном, cosφ= 1), для счетчика непосредственного включения, % от Iб',
                    value: '0,4'
                },
                {
                    title: 'Количество тарифов',
                    value: 'до 4'
                },
                {
                    title: 'Постоянная счетчика, имп./кВт·ч',
                    value: '1000'
                }
            ],
            description: '<p>Счетчики ЦЭ2727А предназначены для многотарифного (до 4 тарифов) ' +
            'учета активной энергии в трехфазных трех- и четырех- проводных сетях переменного тока номинальной частотой 50 Гц.<br />' +
            'Счетчики соответствуют требованиям ГОСТ 31818.11-2012, ГОСТ 31819.21-2012. ' +
            'Счетчики устанавливаются внутри помещений, рабочий диапазон температур от минус 40 ºС до плюс 70 ºС. ' +
            'Подключаются непосредственно к электрической сети. ' +
            'Степень защиты корпуса счетчика от проникновения воды и пыли внутрь счетчика соответствует IP51. ' +
            'Ежемесячная абонентская плата за автоматическую передачу показаний - 20р/мес.</p>',
            labels: [],
            warranty: 'Гарантия 5 лет'
        },
        CE2727A560R: {
            name: 'ЦЭ2727А.S.RF.ОР.5-60.В04.Z',
            short: 'Электронный трёхфазный счетчик с реле',
            heading: 'Электронный трехфазный счетчик ЦЭ2727А в плоском B04, с оптопортом, реле ограничения нагрузки и встроенным модулем LoRaWAN',
            imageUrl: 'product_electr_CE_B04.jpeg',
            advantage: 'Автоматическая передача данных в ГИС ЖКХ',
            advantageShort: 'Автопередача показаний',
            advantageSecondary: '<span class="orange">Пользуется большим спросом!</span>',
            inStock: true,
            inStockText: 'Товар в наличии',
            notInStockText: 'Под заказ',
            inStockImage: 'done.svg',
            delivery: 'Бесплатная доставка по Новосибирску',
            price: '8240',
            currency: 'руб',
            buyButton: 'Заказать',
            productCode: '135449487',
            downloads: [
                {link: '/', name: 'Руководство по эксплуатации'},
                {link: '/', name: 'Драйвер для COM-порта'},
                {link: '/', name: 'Свидетельство об утверждении типа СИ'},
                {link: '/', name: 'Декларация соответствия ТР ТС'},
            ],
            excellence: [
                {icon: 'calendar.svg', name: 'Автоматическая передача<br />показаний в выбраный день'},
                {icon: 'broadcast.svg', name: 'Опрос счетчиков в<br />любое время'},
                {icon: 'check-form.svg', name: 'Хранит журнал показаний<br />и отчеты потребления'},
                {icon: 'time-left.svg', name: 'Беспроводная передача<br />данных из труднодоступных мест'}
            ],
            characteristics: [
                {
                    title: 'Номинальное напряжение, В',
                    value: '3x 220/380; 3x230/400'
                },
                {
                    title: 'Базовый - Максимальный ток, А',
                    value: '5-10'
                },
                {
                    title: 'Стартовый ток (порог чувствительности) (при U= Uном, cosφ= 1), для счетчика непосредственного включения, % от Iб',
                    value: '0,4'
                },
                {
                    title: 'Количество тарифов',
                    value: 'до 4'
                },
                {
                    title: 'Постоянная счетчика, имп./кВт·ч',
                    value: '1000'
                }
            ],
            description: '<p>Счетчики ЦЭ2727А предназначены для многотарифного (до 4 тарифов) ' +
            'учета активной энергии в трехфазных трех- и четырех- проводных сетях переменного тока номинальной частотой 50 Гц.<br />' +
            'Счетчики соответствуют требованиям ГОСТ 31818.11-2012, ГОСТ 31819.21-2012. ' +
            'Счетчики устанавливаются внутри помещений, рабочий диапазон температур от минус 40 ºС до плюс 70 ºС. ' +
            'Подключаются непосредственно к электрической сети. ' +
            'Оснащен реле ограничения нагрузки. Степень защиты корпуса счетчика от проникновения воды и пыли внутрь счетчика соответствует IP51. ' +
            'Ежемесячная абонентская плата за автоматическую передачу показаний - 20р/мес.</p>',
            labels: [],
            warranty: 'Гарантия 5 лет'
        },
        CE2727A10100: {
            name: 'ЦЭ2727А.S.RF.ОР.10-100.В04',
            short: 'Электронный трёхфазный счетчик',
            heading: 'Электронный трехфазный счетчик ЦЭ2727А в плоском B04, с оптопортом и встроенным модулем LoRaWAN',
            imageUrl: 'product_electr_CE_B04.jpeg',
            advantage: 'Автоматическая передача данных в ГИС ЖКХ',
            advantageShort: 'Автопередача показаний',
            advantageSecondary: '<span class="orange">Пользуется большим спросом!</span>',
            inStock: true,
            inStockText: 'Товар в наличии',
            notInStockText: 'Под заказ',
            inStockImage: 'done.svg',
            delivery: 'Бесплатная доставка по Новосибирску',
            price: '7300',
            currency: 'руб',
            buyButton: 'Заказать',
            productCode: '135449487',
            downloads: [
                {link: '/', name: 'Руководство по эксплуатации'},
                {link: '/', name: 'Драйвер для COM-порта'},
                {link: '/', name: 'Свидетельство об утверждении типа СИ'},
                {link: '/', name: 'Декларация соответствия ТР ТС'},
            ],
            excellence: [
                {icon: 'calendar.svg', name: 'Автоматическая передача<br />показаний в выбраный день'},
                {icon: 'broadcast.svg', name: 'Опрос счетчиков в<br />любое время'},
                {icon: 'check-form.svg', name: 'Хранит журнал показаний<br />и отчеты потребления'},
                {icon: 'time-left.svg', name: 'Беспроводная передача<br />данных из труднодоступных мест'}
            ],
            characteristics: [
                {
                    title: 'Номинальное напряжение, В',
                    value: '3x 220/380; 3x230/400'
                },
                {
                    title: 'Базовый - Максимальный ток, А',
                    value: '5-10'
                },
                {
                    title: 'Стартовый ток (порог чувствительности) (при U= Uном, cosφ= 1), для счетчика непосредственного включения, % от Iб',
                    value: '0,4'
                },
                {
                    title: 'Количество тарифов',
                    value: 'до 4'
                },
                {
                    title: 'Постоянная счетчика, имп./кВт·ч',
                    value: '500'
                }
            ],
            description: '<p>Счетчики ЦЭ2727А предназначены для многотарифного (до 4 тарифов) ' +
            'учета активной энергии в трехфазных трех- и четырех- проводных сетях переменного тока номинальной частотой 50 Гц.<br />' +
            'Счетчики соответствуют требованиям ГОСТ 31818.11-2012, ГОСТ 31819.21-2012. ' +
            'Счетчики устанавливаются внутри помещений, рабочий диапазон температур от минус 40 ºС до плюс 70 ºС. ' +
            'Подключаются непосредственно к электрической сети. ' +
            'Степень защиты корпуса счетчика от проникновения воды и пыли внутрь счетчика соответствует IP51. ' +
            'Ежемесячная абонентская плата за автоматическую передачу показаний - 20р/мес.</p>',
            labels: [],
            warranty: 'Гарантия 5 лет'
        },
        // CE2726A: {
        //     name: 'ЦЭ2726А',
        //     short: 'Счетчик электрической энергии однофазный электронный',
        //     heading: 'Счетчик электрической энергии однофазный электронный, ЦЭ2726А (счетчик +радиомодуль)',
        //     imageUrl: 'product_electr_CE_W03.png',
        //     advantage: 'Автоматическая передача данных в ГИС ЖКХ',
        //     advantageShort: 'Автопередача показаний',
        //     advantageSecondary: '<span class="orange">Пользуется большим спросом!</span>',
        //     inStock: true,
        //     inStockText: 'Товар в наличии',
        //     notInStockText: 'Под заказ',
        //     inStockImage: 'done.svg',
        //     delivery: 'Бесплатная доставка по Новосибирску',
        //     price: '2 455',
        //     currency: 'руб',
        //     buyButton: 'Заказать',
        //     productCode: '135449487',
        //     downloads: [
        //         {link: '/', name: 'Руководство по эксплуатации'},
        //         {link: '/', name: 'Драйвер для COM-порта'},
        //         {link: '/', name: 'Свидетельство об утверждении типа СИ'},
        //         {link: '/', name: 'Декларация соответствия ТР ТС'},
        //     ],
        //     excellence: [
        //         {icon: 'calendar.svg', name: 'Автоматическая передача<br />показаний в выбраный день'},
        //         {icon: 'broadcast.svg', name: 'Опрос счетчиков в<br />любое время'},
        //         {icon: 'check-form.svg', name: 'Хранит журнал показаний<br />и отчеты потребления'},
        //         {icon: 'time-left.svg', name: 'Беспроводная передача<br />данных из труднодоступных мест'}
        //     ],
        //     characteristics: [
        //         'Диапаззон рабочего давления воды до 1МПА',
        //         'Диапаззон рабочих температур воды для СХВЭ +5...+50 °С',
        //         'Способ активации в сети LoRaWAN™<br />ABP или OTAA',
        //         'Диаметр условного прохода 15 или 20мм',
        //         'Диапаззон рабочего давления воды до 1МПА',
        //         'Диапаззон рабочих температур воды для СХВЭ +5...+50 °С',
        //         'Способ активации в сети LoRaWAN™<br />ABP или OTAA',
        //         'Диаметр условного прохода 15 или 20мм'
        //     ],
        //     description: '<p>Счетчик электронный крыльчатый применяется для ' +
        //     'учета расхода холодной и горячей воды с накоплением и передачей этих данных в сеть LaRoWAN<br />' +
        //     'Функция "Электронная антимагнитная пломба" фиксирует воздействие внешним магнитным полем и' +
        //     'блокирует отображение показаний на дисплее устройства.</p><p>Счетчики выпускаются в двух' +
        //     'исполнениях: с диаметром условного прохода 15мм - 20мм </p>',
        //     labels: [
        //         {icon: 'Group 3069.svg', tip: 'Обеспечивает милиампер часы милиамперным милиамперметром'},
        //         {
        //             icon: 'Group 3070.svg',
        //             tip: 'Обеспечивает защиту от воды и других жидкостей только в виде капель и не защищает от струй воды'
        //         },
        //         {
        //             icon: 'Group 3071.svg',
        //             tip: 'Обеспечивает защиту от воды и других жидкостей только в виде капель и не защищает от струй воды'
        //         },
        //         {
        //             icon: 'Group 30699.svg',
        //             tip: 'Обеспечивает защиту от воды и других жидкостей только в виде капель и не защищает от струй воды'
        //         },
        //         {
        //             icon: 'Group 30711.svg',
        //             tip: 'Обеспечивает защиту от воды и других жидкостей только в виде капель и не защищает от струй воды'
        //         },
        //         {
        //             icon: '5kPaGray.svg',
        //             tip: 'Обеспечивает защиту от воды и других жидкостей только в виде капель и не защищает от струй воды'
        //         }
        //     ],
        //     warranty: 'Гарантия 5 лет'
        // },
        // Mercury206: {
        //     name: 'Меркурий 206',
        //     short: 'Счетчик электрической энергии однофазный электронный',
        //     heading: 'Счетчик электрической энергии однофазный электронный, Меркурий 206 (счетчик +радиомодуль)',
        //     imageUrl: 'c_8.png',
        //     advantage: 'Автоматическая передача данных в ГИС ЖКХ',
        //     advantageShort: 'Автопередача показаний',
        //     advantageSecondary: '<span class="orange">Пользуется большим спросом!</span>',
        //     inStock: true,
        //     inStockText: 'Товар в наличии',
        //     notInStockText: 'Под заказ',
        //     inStockImage: 'done.svg',
        //     delivery: 'Бесплатная доставка по Новосибирску',
        //     popular: true,
        //     oldPrice: '4 455',
        //     price: '3 005',
        //     currency: 'руб',
        //     buyButton: 'Заказать',
        //     productCode: '135449487',
        //     downloads: [
        //         {link: '/', name: 'Руководство по эксплуатации'},
        //         {link: '/', name: 'Драйвер для COM-порта'},
        //         {link: '/', name: 'Свидетельство об утверждении типа СИ'},
        //         {link: '/', name: 'Декларация соответствия ТР ТС'},
        //     ],
        //     excellence: [
        //         {icon: 'calendar.svg', name: 'Автоматическая передача<br />показаний в выбраный день'},
        //         {icon: 'broadcast.svg', name: 'Опрос счетчиков в<br />любое время'},
        //         {icon: 'check-form.svg', name: 'Хранит журнал показаний<br />и отчеты потребления'},
        //         {icon: 'time-left.svg', name: 'Беспроводная передача<br />данных из труднодоступных мест'}
        //     ],
        //     characteristics: [
        //         'Диапаззон рабочего давления воды до 1МПА',
        //         'Диапаззон рабочих температур воды для СХВЭ +5...+50 °С',
        //         'Способ активации в сети LoRaWAN™<br />ABP или OTAA',
        //         'Диаметр условного прохода 15 или 20мм',
        //         'Диапаззон рабочего давления воды до 1МПА',
        //         'Диапаззон рабочих температур воды для СХВЭ +5...+50 °С',
        //         'Способ активации в сети LoRaWAN™<br />ABP или OTAA',
        //         'Диаметр условного прохода 15 или 20мм'
        //     ],
        //     description: '<p>Счетчик электронный крыльчатый применяется для ' +
        //     'учета расхода холодной и горячей воды с накоплением и передачей этих данных в сеть LaRoWAN<br />' +
        //     'Функция "Электронная антимагнитная пломба" фиксирует воздействие внешним магнитным полем и' +
        //     'блокирует отображение показаний на дисплее устройства.</p><p>Счетчики выпускаются в двух' +
        //     'исполнениях: с диаметром условного прохода 15мм - 20мм </p>',
        //     labels: [
        //         {icon: 'Group 3069.svg', tip: 'Обеспечивает милиампер часы милиамперным милиамперметром'},
        //         {
        //             icon: 'Group 3070.svg',
        //             tip: 'Обеспечивает защиту от воды и других жидкостей только в виде капель и не защищает от струй воды'
        //         },
        //         {
        //             icon: 'Group 3071.svg',
        //             tip: 'Обеспечивает защиту от воды и других жидкостей только в виде капель и не защищает от струй воды'
        //         },
        //         {
        //             icon: 'Group 30699.svg',
        //             tip: 'Обеспечивает защиту от воды и других жидкостей только в виде капель и не защищает от струй воды'
        //         },
        //         {
        //             icon: 'Group 30711.svg',
        //             tip: 'Обеспечивает защиту от воды и других жидкостей только в виде капель и не защищает от струй воды'
        //         },
        //         {
        //             icon: '5kPaGray.svg',
        //             tip: 'Обеспечивает защиту от воды и других жидкостей только в виде капель и не защищает от струй воды'
        //         }
        //     ],
        //     warranty: 'Гарантия 5 лет'
        // },
        // CE2727A: {
        //     name: 'ЦЭ2727А',
        //     short: 'Счетчик электрической энергии трехфазный электронный',
        //     heading: 'Счетчик электрической энергии трехфазный электронный, ЦЭ2727А (счетчик +радиомодуль)',
        //     imageUrl: 'c_9.png',
        //     advantage: 'Автоматическая передача данных в ГИС ЖКХ',
        //     advantageShort: 'Автопередача показаний',
        //     advantageSecondary: '<span class="orange">Пользуется большим спросом!</span>',
        //     inStock: true,
        //     inStockText: 'Товар в наличии',
        //     notInStockText: 'Под заказ',
        //     inStockImage: 'done.svg',
        //     delivery: 'Бесплатная доставка по Новосибирску',
        //     price: '2 455',
        //     currency: 'руб',
        //     buyButton: 'Заказать',
        //     productCode: '135449487',
        //     downloads: [
        //         {link: '/', name: 'Руководство по эксплуатации'},
        //         {link: '/', name: 'Драйвер для COM-порта'},
        //         {link: '/', name: 'Свидетельство об утверждении типа СИ'},
        //         {link: '/', name: 'Декларация соответствия ТР ТС'},
        //     ],
        //     excellence: [
        //         {icon: 'calendar.svg', name: 'Автоматическая передача<br />показаний в выбраный день'},
        //         {icon: 'broadcast.svg', name: 'Опрос счетчиков в<br />любое время'},
        //         {icon: 'check-form.svg', name: 'Хранит журнал показаний<br />и отчеты потребления'},
        //         {icon: 'time-left.svg', name: 'Беспроводная передача<br />данных из труднодоступных мест'}
        //     ],
        //     characteristics: [
        //         'Диапаззон рабочего давления воды до 1МПА',
        //         'Диапаззон рабочих температур воды для СХВЭ +5...+50 °С',
        //         'Способ активации в сети LoRaWAN™<br />ABP или OTAA',
        //         'Диаметр условного прохода 15 или 20мм',
        //         'Диапаззон рабочего давления воды до 1МПА',
        //         'Диапаззон рабочих температур воды для СХВЭ +5...+50 °С',
        //         'Способ активации в сети LoRaWAN™<br />ABP или OTAA',
        //         'Диаметр условного прохода 15 или 20мм'
        //     ],
        //     description: '<p>Счетчик электронный крыльчатый применяется для ' +
        //     'учета расхода холодной и горячей воды с накоплением и передачей этих данных в сеть LaRoWAN<br />' +
        //     'Функция "Электронная антимагнитная пломба" фиксирует воздействие внешним магнитным полем и' +
        //     'блокирует отображение показаний на дисплее устройства.</p><p>Счетчики выпускаются в двух' +
        //     'исполнениях: с диаметром условного прохода 15мм - 20мм </p>',
        //     labels: [
        //         {icon: 'Group 3069.svg', tip: 'Обеспечивает милиампер часы милиамперным милиамперметром'},
        //         {
        //             icon: 'Group 3070.svg',
        //             tip: 'Обеспечивает защиту от воды и других жидкостей только в виде капель и не защищает от струй воды'
        //         },
        //         {
        //             icon: 'Group 3071.svg',
        //             tip: 'Обеспечивает защиту от воды и других жидкостей только в виде капель и не защищает от струй воды'
        //         },
        //         {
        //             icon: 'Group 30699.svg',
        //             tip: 'Обеспечивает защиту от воды и других жидкостей только в виде капель и не защищает от струй воды'
        //         },
        //         {
        //             icon: 'Group 30711.svg',
        //             tip: 'Обеспечивает защиту от воды и других жидкостей только в виде капель и не защищает от струй воды'
        //         },
        //         {
        //             icon: '5kPaGray.svg',
        //             tip: 'Обеспечивает защиту от воды и других жидкостей только в виде капель и не защищает от струй воды'
        //         }
        //     ],
        //     warranty: 'Гарантия 5 лет'
        // }
    },
    heat: {},
    sensor: {}
}

export default {
    state
}


// WEBPACK FOOTER //
// ./src/store/modules/products/products.js